import { render } from "./Lab.vue?vue&type=template&id=fd7a0304&scoped=true"
import script from "./Lab.vue?vue&type=script&lang=js"
export * from "./Lab.vue?vue&type=script&lang=js"

import "./Lab.vue?vue&type=style&index=0&id=fd7a0304&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7a0304"]])

export default __exports__